import axios from './axios.js'


// 获取商户下全部店铺信息
export function getStoreMessageAll() {
  return axios.get(`/third_management/list`)
}
// 按需查询门店商户列表
export function getStoreMessage(store,tag,page,limit) {
  return axios.get(`/third_management/get_merchants?store=${store}&tag=${tag}&page=${page}&limit=${limit}`)
}
// 添加门店商户
export function addStoreMessage(data) {
  return axios.post(`/third_management/set_merchants`,data)
}
// 修改门店商户信息
export function updateStoreMessage(data) {
  return axios.put(`/third_management/set_merchants`,data)
}
// 删除门店商户
export function deleteStoreMessage(id) {
  return axios.delete(`/third_management/set_merchants?id=${id}`)
}

// 获取门店套餐参数列表
export function getStoreParamsMessage(store,payType,page,limit) {
  return axios.get(`/third_management/get_group_package?store=${store}&payType=${payType}&page=${page}&limit=${limit}`)
}

// 添加门店套餐参数
export function addStoreParamsMessage(data) {
  return axios.post(`/third_management/set_group_package`,data)
}

// 修改门店套餐参数
export function updateStoreParamsMessage(data) {
  return axios.put(`/third_management/set_group_package`,data)
}

// 删除门店套餐参数
export function deleteStoreParamsMessage(id,store) {
  return axios.delete(`/third_management/set_group_package?id=${id}&store=${store}`)
}

// 获取会员卡类型
export function storeInfoCardType(storeId) { 
    return axios.get(`third_management/infoCard?storeId=${storeId}`)
}

// 门店项目管理列表接口
export function storeClassification(data) {
    return axios.post("third_management/page", data)
}

// 添加会员协议
export function addAgreement(data) {
    return axios.post("shop/membership/agreement", data)
}


// 获取会员协议
export function getAgreement() {
    return axios.get(`shop/membership/agreement/list`)
}

// 获取是否启用会员协议
export function enableAgreement() {
    return axios.get(`shop/enable-membership-agreement/by-merchants-id`)
}

// 修改会员协议
export function updateAgreement(data) {
    return axios.post("shop//enable-membership-agreement/enable", data)
}


// WEBPACK FOOTER //
// ./src/api/admin.js